<template>
	<div class='container flex-center'>
		<div class='content flex-center'>
			<div v-if="loading">
				<div>
					<div class='container-loader'>
						{{ $t("components.paypal_checkout.process") }}
					</div>
				</div>

				<loading-spin :height='100'></loading-spin>
			</div>

			<div v-if='!loading && errorStore.message'>
				<div>
					Si è verificato un errore:
				</div>

				<div class='error'>
					{{ errorStore.message }}
				</div>

				<div>
					<span class='link-detail' @click="goBack()">{{ $t("components.paypal_checkout.link") }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Subscription } from '../../core/Subscription'
import { container } from '../../services/container'
import { OrderApi } from '../../api/OrderApi'

import { errorStore } from '../../store/errorStore'
import { ABtest } from '../../services/abtest'
import { stripeHelper } from '../../mixins/stripeHelper'

export default {
  mixins: [
    stripeHelper
  ],
	data () {
		return {
			ABtest: ABtest.state,
			loading: true,

			errorStore: errorStore.state
		}
	},
	computed: {
		user () {
			return this.$root.user
		}
	},
	methods: {
		goBack () {
			var refer = this.$route.params.refer
			if (refer === 'prova-ora') this.$router.push({ name: 'order-now' })
			if (refer === 'checkout') this.$router.push({ name: 'flow-new' })
			if (refer === 'profile') this.$router.push({ name: 'profile_payment', params: { error: errorStore.message, state: 'error' } })
		}
	},
	mounted () {
		ABtest.setVariant()

		var result = this.$route.params.status
		var refer = this.$route.params.refer

		var user = this.user
		if (!this.user || result === 'cancel') {
			this.loading = false
			errorStore.updateMessage('Errore')
			return
		}
		var api = new OrderApi()
		api.confirmPaypal({
			paypal_token: this.$route.query.token,
			subscription_token: user.subscription.token
		}).catch(response => {

        errorStore.formatMessage(response)
        if (response && response.body.errors) this.errorCode = response.body.errors[0].code
        this.errorOrderNowFrode = 'Non è possibile usufruire dell\'offerta poiché risulta già utilizzata con questo metodo di pagamento'
        if (refer === 'prova-ora') {
          this.$router.push({
            name: 'order-now', 
            params: { error: this.errorCode === 'FRAUD_COUPON_DUPLICATE'
              ? this.errorOrderNowFrode
              : errorStore.message
            }
          })
        }
        if (refer === 'check' || refer === 'checkout') 
          this.$router.push({ name: 'flow-new' })

        if (refer === 'profile') 
          this.$router.push({ name: 'profile_payment', params: { error: errorStore.message, state: 'error' } })
        
      }).then(response => {
        return this.confirmStripeAndPaypal(refer);
		})
	}
}

</script>

<style scoped>
	.error {
		margin: 10px 0;
	}
	.content {
		text-align: center;
	}
</style>
